import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import AIButton from 'ai-components-ui-library/components/buttons/AIButton';
import { Flex } from 'foundations-components/components/Flex';
import { Link } from 'foundations-components/transitional/components/Link';
import useCloneTracker from '../../../../hooks/useCloneTracker';
import useFetchIsAIEnabledFromSettings from '../../fullPage/report-ai-assistant-insights/useFetchIsAIEnabledFromSettings';
import { AIReportSummaryHeaderTitle } from './AIReportSummaryHeaderTitle';
import { AISettingsButton } from './ai-settings/AISettingsButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AIReportSummaryHeader = ({
  appUsageTracker,
  isSummaryExpanded,
  setIsSummaryExpanded,
  report,
  reportResolve,
  onReportChange
}) => {
  const tracker = useCloneTracker(appUsageTracker);
  const isAIEnabled = useFetchIsAIEnabledFromSettings();
  if (!isSummaryExpanded) {
    return /*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      flexDirection: "row",
      children: [/*#__PURE__*/_jsx(AIReportSummaryHeaderTitle, {}), /*#__PURE__*/_jsx(AIButton, {
        display: "flex",
        alignItems: "center",
        size: "xs",
        disabled: !isAIEnabled,
        tooltip: !isAIEnabled && /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "reporting-enablement.singleReportViewer.AIReportSummary.insights.disabledTooltip_jsx",
          elements: {
            UILink: Link
          },
          options: {
            external: true,
            href: `/ai-settings/${PortalIdParser.get()}`,
            target: 'blank'
          }
        }),
        usageTracker: tracker,
        onClick: () => setIsSummaryExpanded(true),
        use: "tertiary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-enablement.singleReportViewer.AIReportSummary.buttons.open"
        })
      })]
    });
  }
  return /*#__PURE__*/_jsxs(Flex, {
    justifyContent: "space-between",
    marginBlockEnd: "400",
    flexDirection: "row",
    gap: "200",
    children: [/*#__PURE__*/_jsx(AIReportSummaryHeaderTitle, {}), /*#__PURE__*/_jsx(AISettingsButton, {
      report: report,
      reportResolve: reportResolve,
      onReportChange: onReportChange
    })]
  });
};